import { motion } from "framer-motion";
import SpeakButton from "@/components/SpeakButton";

/**
 * Shared layout wrapper for each wizard step.
 * Keeps the visual rhythm consistent: pill, heading, AI-bubble intro, content slot, footer actions.
 */
export default function WizardShell({
  pillLabel,
  pillColor = "#4aa0a4",
  headline,
  aiOpening,
  children,
  footer,
  testid,
}) {
  const speakable = [headline, aiOpening].filter(Boolean).join(". ");
  return (
    <motion.div
      key={pillLabel}
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      data-testid={testid}
    >
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div
          className="weave-step-pill"
          style={{
            borderColor: `${pillColor}40`,
            background: `${pillColor}10`,
            color: pillColor,
          }}
        >
          <span
            className="weave-dot"
            style={{ background: pillColor }}
            aria-hidden="true"
          />
          {pillLabel}
        </div>
        {speakable && (
          <SpeakButton
            text={speakable}
            label="Read this step aloud"
            testid="shell-speak-btn"
          />
        )}
      </div>

      <h2 className="mt-6 text-3xl md:text-4xl font-light text-slate-800 tracking-tight leading-tight">
        {headline}
      </h2>

      {aiOpening && (
        <div className="mt-8 weave-bubble-ai" data-testid="ai-opening">
          <div className="flex items-center justify-between gap-4 mb-2">
            <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
              Trusted Peer
            </div>
          </div>
          <div className="text-slate-700 whitespace-pre-line">{aiOpening}</div>
        </div>
      )}

      <div className="mt-8">{children}</div>

      {footer && (
        <div className="mt-10 flex items-center justify-between gap-4">
          {footer}
        </div>
      )}
    </motion.div>
  );
}
